import { getApiErrorData } from '../../../../../../_metronic/helpers'
import { ApiErrorData } from '../../../../../../_metronic/helpers/BuildErrorMessage'
import { LotacaoElegivel } from './_models'

export const LOTACAO_SOLICITANTE_AMBIGUA = 'LOTACAO_SOLICITANTE_AMBIGUA'

type ErroLotacaoAmbigua = ApiErrorData & { code?: string; lotacoes?: LotacaoElegivel[] }

/**
 * Lotações elegíveis do 422 `LOTACAO_SOLICITANTE_AMBIGUA`: o solicitante tem mais de uma lotação
 * vigente na unidade e nenhuma foi informada, então o backend recusa a abertura e devolve as opções.
 * `undefined` para qualquer outro erro.
 */
export const lotacoesDaAmbiguidade = (error: unknown): LotacaoElegivel[] | undefined => {
  const dados = getApiErrorData(error) as ErroLotacaoAmbigua | undefined
  if (dados?.code !== LOTACAO_SOLICITANTE_AMBIGUA || !dados.lotacoes?.length) return undefined
  return dados.lotacoes
}

/** Mesmo rótulo do seletor montado a partir das lotações do solicitante: unidade · CBO · INE. */
export const descreveLotacaoElegivel = (lotacao: LotacaoElegivel) =>
  [
    lotacao.unidade,
    lotacao.cbo && `CBO ${lotacao.cbo}${lotacao.descricaoCbo ? ` - ${lotacao.descricaoCbo}` : ''}`,
    lotacao.ine && `INE ${lotacao.ine}`,
  ]
    .filter(Boolean)
    .join(' · ')
